import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { addressLine1, addressLine2 } from '../../utils/address';
import UpdateAddressButton from '../UpdateAddressButton';

const AddressRow = ({
  address,
  prefillEdit = true,
  showEditLink = true,
  style,
}) => (
  <div className={style.rowContainer}>
    <div className={style.rowContent} data-testid="overview-address">
      <p className={style.noMarginBottom}>{addressLine1(address)}</p>
      <p className={`${style.noMarginTop} ${style.noMarginBottom}`}>
        {addressLine2(address)}
      </p>
    </div>
    <div className={style.editButton}>
      {showEditLink && (
        <UpdateAddressButton address={prefillEdit ? address : undefined} />
      )}
    </div>
  </div>
);

AddressRow.propTypes = {
  address: PropTypes.object.isRequired,
  prefillEdit: PropTypes.bool,
  showEditLink: PropTypes.bool,
  style: PropTypes.shape({
    rowContainer: PropTypes.string,
    rowContent: PropTypes.string,
    editButton: PropTypes.string,
    noMarginBottom: PropTypes.string,
    noMarginTop: PropTypes.string,
  }).isRequired,
};

export default memo(AddressRow);
